import React from 'react'
import styled, { css } from 'styled-components'
import ButtonAlarm from 'components/Button/ButtonAlarm'
import ScheduleBottomOverlay from 'components/Schedule/ScheduleBottomOverlay'
import { layoutSmall } from 'core/util/default'

const ScheduleImage: React.FC<TypeScheduleItem> = (props) => {
  const {
    className,
    title,
    broadcastId,
    useAlarm,
    etcLinkUrl,
    etcLinkOpenType,
    thumbnail,
    LinkButtonTagAttributes,
    isShowPurchaseAuthBadge,
    onClickAlarm,
    isConfirmAlarm,
  } = props

  const handleClickAlarm = () => {
    if (!etcLinkUrl) {
      onClickAlarm && onClickAlarm(broadcastId)
      return
    }

    if (etcLinkOpenType === 'move') {
      return (window.location.href = etcLinkUrl)
    }
    if (etcLinkOpenType === 'open') {
      return window.open(etcLinkUrl, '_blank')
    }
    return
  }

  return (
    <StyledScheduleImage className={className}>
      <button {...LinkButtonTagAttributes} className="schedule_wrapper">
        <ScheduleBottomOverlay isShowPurchaseAuthBadge={isShowPurchaseAuthBadge} />
        <img src={thumbnail} alt={title} />
      </button>
      <div className="button_area">
        {useAlarm && <ButtonAlarm isAlarm={isConfirmAlarm} onClick={handleClickAlarm} />}
      </div>
    </StyledScheduleImage>
  )
}

const StyledScheduleImage = styled.div`
  position: relative;
  .schedule_wrapper {
    position: relative;
    display: block;
    width: 384px;
    height: 288px;
    padding: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: transparent;
    border: solid 1px ${({ theme }) => theme.thumbnailLineColor};

    cursor: pointer;
    img {
      width: inherit;
      height: inherit;
    }
  }
  .button_area {
    position: absolute;
    right: 20px;
    bottom: 10px;
    display: flex;
    justify-content: right;
    width: 100%;
  }
  ${layoutSmall(css`
    .schedule_wrapper {
      width: 323px;
      height: 243px;
    }
  `)}
`
export default ScheduleImage
